/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import * as Sentry from '@sentry/react';
import Config from 'Config';
import { resetAllStores } from 'common/stores/redux/store';

/**
 * Clear the account cache, by default clears the entire account cache unless optional cache name is provided
 * @param {string} cache the cache to clear (optional)
 * @returns {undefined}
 */
export function clearCache(cache = '') {
    if (cache) {
        localStorage.removeItem(`${Config.storageNameSpace}.${cache}`);
    } else {
        localStorage.removeItem(`${Config.storageNameSpace}.token`);
        localStorage.removeItem(`${Config.storageNameSpace}.client`);
        localStorage.removeItem(`${Config.storageNameSpace}.contractor`);
        localStorage.removeItem(`${Config.storageNameSpace}.acknowledgement`);
    }
}

/**
 * Check to see if a session exists
 * @returns {boolean}
 */
export function isLoggedIn() {
    return !!localStorage.getItem(`${Config.storageNameSpace}.token`);
}

/**
 * Logout
 */
export function clearAuthenticationCache() {
    if (!isLoggedIn()) {
        document.dispatchEvent(new CustomEvent('onParentLogout'));
    }
    clearCache();
    // Reset all stores to initial state
    resetAllStores();
    Sentry.setUser(null);
}
